/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './Renegociacao25EmpVantagens.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import RedButton from '@/components/atoms/RedButton';

function Renegociacao25EmpVantagens() {
  return (
    <>
      <section id="renegociacao25-emp-vantagens">
        <img
          src="assets/renegociacao25-emp/vantagens/santander-symbol.svg"
          alt=""
          className="santander-symbol"
        />
        <ContainerHome24>
          <h2 className="vantagens-titulo">Confira as vantagens de renegociar seu empréstimo</h2>
          <div className="vantagens-carrossel">
            <CustomEmblaCarouselHome24
              // loop
              enableBullets
              detectBulletCount
              // hideOverflow
              enableMobileArrows
              enablePrevArrow
              //autoplay={100000}
            >
              {({ className }) => (
                <>
                  <div className={`slide ${className}`}>
                    <img src="assets/renegociacao25-emp/vantagens/ic_offer.svg" alt="" />
                    <div className="slide-textos">
                      <h4 className="slide-titulo">Melhores propostas</h4>
                      <p className="slide-texto">As melhores ofertas para sua renegociação.</p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <img src="assets/renegociacao25-emp/vantagens/ic_seguranca.svg" alt="" />
                    <div className="slide-textos">
                      <h4 className="slide-titulo">Segurança</h4>
                      <p className="slide-texto">
                        Informações sobre você ou sua empresa estão seguras com a gente.
                      </p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <img
                      src="assets/renegociacao25-emp/vantagens/ic_checking_account_closing.svg"
                      alt=""
                    />
                    <div className="slide-textos">
                      <h4 className="slide-titulo">Sem custos extras</h4>
                      <p className="slide-texto">Consulte seu CPF gratuitamente.</p>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <img src="assets/renegociacao25-emp/vantagens/ic_mobile.svg" alt="" />
                    <div className="slide-textos">
                      <h4 className="slide-titulo">Tecnologia</h4>
                      <p className="slide-texto">
                        Faça tudo de casa com toda facilidade e segurança.
                      </p>
                    </div>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>
          <RedButton
            href="https://quiteja.com.br/parceiros/sim"
            rel="noopener"
            target="_blank"
            className="btn-vantagens-renegociar"
          >
            Quero renegociar
          </RedButton>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Renegociacao25EmpVantagens;
